function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.3 41.2L.7 25.6a2.4 2.4 0 010-3.4l3.4-3.4a2.4 2.4 0 013.4 0L18 29.32l22.5-22.5a2.4 2.4 0 013.4 0l3.4 3.39a2.4 2.4 0 010 3.4L19.7 41.2a2.4 2.4 0 01-3.4 0z"
})));